<template>
  


  <section class="preview">

    
    


    <form class="form" novalidate @submit.prevent="crear">
      <!-- Styled -->

      
      <mdb-input
        placeholder="Nombre Completo"
        class="mb-3 mt-0"
        v-model="name"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Nombre</span>
      </mdb-input>

      
      <mdb-input
        placeholder="Local"
        class="mb-3 mt-0"
        v-model="category"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Categoria</span>
      </mdb-input>

      <mdb-input
        placeholder="Movil"
        class="mb-3 mt-0"
        v-model="page_id"
        required
        invalidFeedback="Coloca el nombre"
      >
        <span class="input-group-text md-addon" slot="prepend">Page id</span>
      </mdb-input>

      

      <div class="form-group">
        <label class="typo__label">Cuentas ads</label>
        <multiselect
          v-model="user_account"
          :options="user_accounts"
          :multiple="false"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Selecciona Cuentas"
          label="name"
          track-by="id"
          :preselect-first="false"
        ></multiselect>
      </div>

     

      <div class="text-center">
        <mdb-btn type="submit" color="primary" :disabled="isLoading">
          <span v-if="!isLoading">Editar</span>
          <semipolar-spinner :animation-duration="2000" :size="30" color="#ffffff" v-if="isLoading"></semipolar-spinner>
        </mdb-btn>
      </div>
    </form>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import ModalCreateStrategyAction from "../notifications/ModalCreateStrategyAction";
import {
  mdbContainer,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip
} from "mdbvue";
import { SemipolarSpinner } from "epic-spinners";
import store from "../../store";
export default {
  name: "modal-1",
  components: {
    mdbContainer,
    ModalCreateStrategyAction,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbModalTitle,
  mdbModalFooter,
  mdbRow,
  mdbBtn,
  mdbIcon,
  mdbTextarea,
  mdbInput,
  mdbTooltip,
    SemipolarSpinner,
    Multiselect
  },
  props: {
    onClick: Function,
    page: Object
  },
  data: () => {
    return {
      isLoading: false,
      id:"",
      name: "",
      category: "",
      page_id: "",
      user_account:{},
      user_accounts:[]
    };
  },
  async mounted() {
    var respuesta = await  await this.getUserAccounts();
    this.id = this.page.id
    this.name = this.page.name
    this.page_id = this.page.page_id
  },
  methods: {
    
    async getUserAccounts() {
      var user_accounts = store.getters.getUserAccounts;
      if (user_accounts.length == 0) {
        await store.dispatch("getUserAccounts").then(() => {
          user_accounts = store.getters.getUserAccounts;
          this.user_accounts = user_accounts;
          return;
        });
      } else {
        this.user_accounts = user_accounts;
        return;
      }
    },
    crear(event) {
      event.target.classList.add("was-validated");
      var {
          id,
        name,
      category,
      page_id,
      user_account
      } = this;

      this.isLoading = true;
      if (
        name == "" ||
        category == "" ||
        page_id == "" 
      ) {
        this.isLoading = false;
      } else {

        var page = {
            id,
          name,
      category,
      page_id,
      user_account_id:user_account.id,
      
        };
        store.dispatch("editPage", page).then(() => {
          this.name = "";
          this.category = "";
          this.onClick();
          this.isLoading = false;
        });
      }
    },
    openModalStrategy(){
      this.modalStrategy();
    },
    
  }
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
.prueba-circulo {
  background-image: url("");
  background-repeat: no-repeat;
  width: 200px;
  height: 200px;
  background: #cccccc;
  border-radius: 100%;
  position: relative;
}
.form {
  position: relative;
  bottom: 80px;
}
</style>